import { render, staticRenderFns } from "./kkdayorder.vue?vue&type=template&id=2b595ae5&scoped=true"
import script from "./kkdayorder.vue?vue&type=script&lang=js"
export * from "./kkdayorder.vue?vue&type=script&lang=js"
import style0 from "./kkdayorder.vue?vue&type=style&index=0&id=2b595ae5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b595ae5",
  null
  
)

export default component.exports